import { render, staticRenderFns } from "./sonPower.vue?vue&type=template&id=444e47c1&scoped=true&"
import script from "./sonPower.vue?vue&type=script&lang=js&"
export * from "./sonPower.vue?vue&type=script&lang=js&"
import style0 from "./sonPower.vue?vue&type=style&index=0&id=444e47c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444e47c1",
  null
  
)

export default component.exports